export default __webpack_public_path__ + "static/media/K_Kurumi.3bc1cf18.mp3";